<template>
  <main>
    <div v-if="authState?.isAuthenticated">
      <div class="container-fluid">
        <div class="card mt-3 mb-2 header-card">
          <div class="row">
            <div class="col-6 col-md-6 col-lg-4">
              <img class="logo-icon img-fluid py-2 ps-3" :src="logoPath" alt="Logo" />
            </div>
            <div
              class="col-6 col-md-6 col-lg-4 heading-26 labeltext d-flex flex-column justify-content-center align-items-center">
              <span>For Internal Consumption Only</span>
            </div>
            <div class="col-6 col-md-6 col-lg-4 text-white d-flex justify-content-end align-items-center">
              <img class="icons-first pe-2" :src="Cal" alt="Calendar Icon" />
              <span class="span1 fw-light pe-3">{{
                daymonthyear(currentDate1)
              }}</span>
              <img class="icons-first px-1 pe-2" :src="Clk" alt="Clock Icon" />
              <span class="span1 fw-light pe-3">{{ currentTime }}</span>
              <img class="icons-first pe-2" :src="Log" alt="Logout Icon" v-on:click="userLogout" />
            </div>
          </div>
        </div>
        <div class="card Ft-payment-card mt-1 text-white" v-show="showText">
          <div class="row">
            <span class="heading-26 pb-1 ms-4 fw-bold">e-Payment Transactions</span>
          </div>
          <div class="row g-0">
            <div class="col-sm-12 col-md-6 col-lg-6">
              <div class="card year-card ps-3 pb-2 pt-3 pe-3 text-white mt-2 me-2 ms-2 mb-1">
                <div class="row">
                  <span class="ms-2 ytd fw-bold">Year-to-Date</span>
                </div>
                <div class="row">
                  <div class="col-3 col-md-3 col-lg-3"></div>
                  <div class="col-3 col-md-3 col-lg-3"></div>
                  <div class="col-6 col-md-6 col-lg-6">
                    <span class="vol">Volume</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3 col-md-3 col-lg-3 d-flex flex-col justify-content-center mb-2">
                    <img :src="volumeImage" class="img-fluid-AR" alt="" />
                  </div>
                  <div class="col-3 col-md-3 col-lg-3">
                    <div class="row">
                      <div class="col-md-6 col-lg-6 px-0">
                        <span class="bluespan volume-label h2 d-flex justify-content-end">{{
                          formatNumber(formattedNumber(YTDVolume)).slice(
                            0,
                            -1
                          )
                        }}</span>
                      </div>
                      <div class="col-md-6 col-lg-6 px-0">
                        <span class="bluespan volume-label h2 ps-1">{{
                          formatNumber(formattedNumber(YTDVolume)).slice(-1)
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-md-6 col-lg-6 d-flex flex-col align-self-center">
                    <span class="bluespan volume-label h2">
                      {{ formatNumber(animatedYTDVolume) }}</span>
                  </div>
                </div>
                <div class="row linebottom"></div>
                <div class="row pt-1">
                  <div class="col-3 col-md-3 col-lg-3"></div>
                  <div class="col-3 col-md-3 col-lg-3"></div>
                  <div class="col-6 col-md-6 col-lg-6">
                    <span class="vol">Value</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3 col-md-3 col-lg-3 d-flex flex-col justify-content-center mb-2">
                    <img :src="RM" class="img-fluid-RM" alt="" />
                  </div>
                  <div class="col-3 col-md-3 col-lg-3">
                    <div class="row">
                      <div class="col-md-6 col-lg-6 px-0">
                        <span class="greenspan volume-label h2 d-flex justify-content-end">{{
                          formatNumber(formattedNumber(YTDValue)).slice(0, -1)
                        }}</span>
                      </div>
                      <div class="col-md-6 col-lg-6 px-0">
                        <span class="greenspan volume-label h2 ps-1">{{
                          formatNumber(formattedNumber(YTDValue)).slice(-1)
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-md-6 col-lg-6 d-flex flex-col align-self-center">
                    <span class="greenspan volume-label h2">RM {{ formatNumber(animatedYTDValue) }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6">
              <div class="card year-card ps-3 pb-2 pt-3 pe-3 text-white mt-2 me-2 mb-1">
                <div class="row">
                  <span class="ms-2 ytd fw-bold">Month-to-Date</span>
                </div>
                <div class="row">
                  <div class="col-3 col-md-3 col-lg-3"></div>
                  <div class="col-3 col-md-3 col-lg-3"></div>
                  <div class="col-6 col-md-6 col-lg-6">
                    <span class="vol">Volume</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3 col-md-3 col-lg-3 d-flex flex-col justify-content-center mb-2">
                    <img :src="volumeImage" class="img-fluid-AR" alt="" />
                  </div>
                  <div class="col-3 col-md-3 col-lg-3">
                    <div class="row">
                      <div class="col-md-6 col-lg-6 px-0">
                        <span class="bluespan volume-label h2 d-flex justify-content-end">{{
                          formatNumber(formattedNumber(MTDVolume)).slice(
                            0,
                            -1
                          )
                        }}</span>
                      </div>
                      <div class="col-md-6 col-lg-6 px-0">
                        <span class="bluespan volume-label h2 ps-1">{{
                          formatNumber(formattedNumber(MTDVolume)).slice(-1)
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-md-6 col-lg-6 d-flex flex-col align-self-center">
                    <span class="bluespan volume-label h2">
                      {{ formatNumber(animatedMTDVolume) }}</span>
                  </div>
                </div>
                <div class="row linebottom"></div>
                <div class="row pt-1">
                  <div class="col-3 col-md-3 col-lg-3"></div>
                  <div class="col-3 col-md-3 col-lg-3"></div>
                  <div class="col-6 col-md-6 col-lg-6">
                    <span class="vol">Value</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3 col-md-3 col-lg-3 d-flex flex-col justify-content-center mb-2">
                    <img :src="RM" class="img-fluid-RM" alt="" />
                  </div>
                  <div class="col-3 col-md-3 col-lg-3">
                    <div class="row">
                      <div class="col-md-6 col-lg-6 px-0">
                        <span class="greenspan volume-label h2 d-flex justify-content-end">{{
                          formatNumber(formattedNumber(MTDValue)).slice(0, -1)
                        }}</span>
                      </div>
                      <div class="col-md-6 col-lg-6 px-0">
                        <span class="greenspan volume-label h2 ps-1">{{
                          formatNumber(formattedNumber(MTDValue)).slice(-1)
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-md-6 col-lg-6 d-flex flex-col align-self-center">
                    <span class="greenspan volume-label h2">RM {{ formatNumber(animatedMTDValue) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <span class="fs-6 fw-light heading-14 d-flex justify-content-end py-1 pe-4 fw-light">Year-to-Date</span>
          </div>
          <div class="d-flex mx-2 Fund-transfer">
            <div class="FT-card-G flex-grow-1 card text-white mb-2 w-25">
              <div class="row pt-3 px-3 dualRow">
                <div class="col-10 col-md-10 col-lg-10">
                  <span class="fs-5 FT-font fw-bold">Fund Transfers</span>
                </div>
                <div class="col-2 col-md-2 col-lg-2 d-flex flex-col justify-content-center">
                  <img class="icons-first-g pe-4" :src="FTW" alt="Logo" />
                </div>
              </div>

              <div class="row px-3">
                <span class="bluespan FT-Blue fs-2">{{
                  formatNumber(FT_Volume)
                }}</span>
              </div>
              <div class="row linebottom1"></div>
              <div class="row pb-3 px-3">
                <span class="greenspan FT-Blue fs-2">RM {{ formatNumber(FT_Value) }}</span>
              </div>
            </div>
            <div class="FT-card-B flex-grow-1 card text-white mb-2 w-25">
              <div class="row pt-3 px-3 dualRow">
                <div class="col-10 col-md-10 col-lg-10">
                  <span class="fs-5 FT-font fw-bold">Online Payments</span>
                </div>
                <div class="col-2 col-md-2 col-lg-2 d-flex flex-col justify-content-center">
                  <img class="icons-first-g pe-4" :src="BO" alt="Logo" />
                </div>
              </div>
              <div class="row px-3">
                <span class="bluespan FT-Blue fs-2">{{
                  formatNumber(BC_Volume)
                }}</span>
              </div>
              <div class="row linebottom1"></div>
              <div class="row pb-3 px-3">
                <span class="greenspan FT-Blue fs-2">RM {{ formatNumber(BC_Value) }}</span>
              </div>
            </div>
            <div class="FT-card-O flex-grow-1 card text-white mb-2 w-25">
              <div class="row pt-3 px-3 dualRow">
                <div class="col-10 col-md-10 col-lg-10">
                  <span class="fs-5 FT-font  fw-bold">In-Store Payments</span>
                </div>
                <div class="col-2 col-md-2 col-lg-2 d-flex flex-col justify-content-center">
                  <img class="icons-first-g pe-4" :src="PSM" alt="Logo" />
                </div>
              </div>
              <div class="row px-3">
                <span class="bluespan FT-Blue fs-2">{{
                  formatNumber(PSM_Volume)
                }}</span>
              </div>
              <div class="row linebottom1"></div>
              <div class="row pb-3 px-3">
                <span class="greenspan FT-Blue fs-2">RM {{ formatNumber(PSM_Value) }}</span>
              </div>
            </div>
            <div class="FT-card-B1 flex-grow-1 card text-white mb-2 w-25">
              <div class="row pt-3 px-3 dualRow">
                <div class="col-10 col-md-10 col-lg-10 d-flex flex-column">
                  <span class="fs-5 FT-font fw-bold">Bill Payments</span>
                </div>
                <div class="col-2 col-md-2 col-lg-2 d-flex flex-col justify-content-center">
                  <img class="icons-first-g pe-4" :src="PB" alt="Logo" />
                </div>
              </div>
              <div class="row px-3">
                <span class="bluespan FT-Blue fs-2">{{
                  formatNumber(PB_Volume)
                }}</span>
              </div>
              <div class="row linebottom1"></div>
              <div class="row pb-3 px-3">
                <span class="greenspan FT-Blue fs-2">RM {{ formatNumber(PB_Value) }}</span>
              </div>
            </div>
            <div class="FT-card-G1 flex-grow-1 card text-white mb-2 w-25">
              <div class="row pt-3 px-3 dualRow">
                <div class="col-10 col-md-10 col-lg-10 d-flex flex-column">
                  <span class="fs-5 FT-font fw-bold">Cross Border Transactions</span>
                </div>
                <div class="col-2 col-md-2 col-lg-2 d-flex flex-col justify-content-center">
                  <img class="icons-first-g pe-4" :src="CB" alt="Logo" />
                </div>
              </div>
              <div class="row px-3">
                <span class="bluespan FT-Blue fs-2">{{
                  formatNumber(CB_Volume)
                }}</span>
              </div>
              <div class="row linebottom1"></div>
              <div class="row pb-3 px-3">
                <span class="greenspan FT-Blue fs-2">RM {{ formatNumber(CB_Value) }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="card Ft-payment-card mt-1 text-white" v-if="!showText">
          <div class="row">
            <span class="heading-26 pb-1 ms-4 fw-bold">e-Payment Transactions</span>
          </div>
          <div class="row g-0">
            <div class="col-sm-12 col-md-6 col-lg-6">
              <div class="card year-card ps-3 pb-2 pt-3 pe-3 text-white mt-2 me-1 ms-2">
                <div class="row">
                  <span class="ms-2 ytd fw-bold">Year-to-Date</span>
                </div>
                <div class="row">
                  <div class="col-3 col-md-3 col-lg-3"></div>
                  <div class="col-3 col-md-3 col-lg-3"></div>
                  <div class="col-6 col-md-6 col-lg-6">
                    <span class="vol">Volume</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3 col-md-3 col-lg-3 d-flex flex-col justify-content-center mb-2">
                    <img :src="volumeImage" class="img-fluid-AR" alt="" />
                  </div>
                  <div class="col-3 col-md-3 col-lg-3">
                    <div class="row">
                      <div class="col-md-6 col-lg-6 px-0">
                        <span class="bluespan volume-label h2 d-flex justify-content-end">{{
                          formatNumber(formattedNumber(YTDVolume)).slice(
                            0,
                            -1
                          )
                        }}</span>
                      </div>
                      <div class="col-md-6 col-lg-6 px-0">
                        <span class="bluespan volume-label h2 ps-1">{{
                          formatNumber(formattedNumber(YTDVolume)).slice(-1)
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-md-6 col-lg-6 d-flex flex-col align-self-center">
                    <span class="bluespan volume-label h2">
                      {{ formatNumber(animatedYTDVolume) }}</span>
                  </div>
                </div>
                <div class="row linebottom"></div>
                <div class="row pt-1">
                  <div class="col-3 col-md-3 col-lg-3"></div>
                  <div class="col-3 col-md-3 col-lg-3"></div>
                  <div class="col-6 col-md-6 col-lg-6">
                    <span class="vol">Value</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3 col-md-3 col-lg-3 d-flex flex-col justify-content-center mb-2">
                    <img :src="RM" class="img-fluid-RM" alt="" />
                  </div>
                  <div class="col-3 col-md-3 col-lg-3">
                    <div class="row">
                      <div class="col-md-6 col-lg-6 px-0">
                        <span class="greenspan volume-label h2 d-flex justify-content-end">{{
                          formatNumber(formattedNumber(YTDValue)).slice(0, -1)
                        }}</span>
                      </div>
                      <div class="col-md-6 col-lg-6 px-0">
                        <span class="greenspan volume-label h2 ps-1">{{
                          formatNumber(formattedNumber(YTDValue)).slice(-1)
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-md-6 col-lg-6 d-flex flex-col align-self-center">
                    <span class="greenspan volume-label h2">RM {{ formatNumber(animatedYTDValue) }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6">
              <div class="card year-card ps-3 pb-2 pt-3 pe-3 text-white mt-2 me-2 ms-1">
                <div class="row">
                  <span class="ms-2 ytd fw-bold">Month-to-Date</span>
                </div>
                <div class="row">
                  <div class="col-3 col-md-3 col-lg-3"></div>
                  <div class="col-3 col-md-3 col-lg-3"></div>
                  <div class="col-6 col-md-6 col-lg-6">
                    <span class="vol">Volume</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3 col-md-3 col-lg-3 d-flex flex-col justify-content-center mb-2">
                    <img :src="volumeImage" class="img-fluid-AR" alt="" />
                  </div>
                  <div class="col-3 col-md-3 col-lg-3">
                    <div class="row">
                      <div class="col-md-6 col-lg-6 px-0">
                        <span class="bluespan volume-label h2 d-flex justify-content-end">{{
                          formatNumber(formattedNumber(MTDVolume)).slice(
                            0,
                            -1
                          )
                        }}</span>
                      </div>
                      <div class="col-md-6 col-lg-6 px-0">
                        <span class="bluespan volume-label h2 ps-1">{{
                          formatNumber(formattedNumber(MTDVolume)).slice(-1)
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-md-6 col-lg-6 d-flex flex-col align-self-center">
                    <span class="bluespan volume-label h2">
                      {{ formatNumber(animatedMTDVolume) }}</span>
                  </div>
                </div>
                <div class="row linebottom"></div>
                <div class="row pt-1">
                  <div class="col-3 col-md-3 col-lg-3"></div>
                  <div class="col-3 col-md-3 col-lg-3"></div>
                  <div class="col-6 col-md-6 col-lg-6">
                    <span class="vol">Value</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3 col-md-3 col-lg-3 d-flex flex-col justify-content-center mb-2">
                    <img :src="RM" class="img-fluid-RM" alt="" />
                  </div>
                  <div class="col-3 col-md-3 col-lg-3">
                    <div class="row">
                      <div class="col-md-6 col-lg-6 px-0">
                        <span class="greenspan volume-label h2 d-flex justify-content-end">{{
                          formatNumber(formattedNumber(MTDValue)).slice(0, -1)
                        }}</span>
                      </div>
                      <div class="col-md-6 col-lg-6 px-0">
                        <span class="greenspan volume-label h2 ps-1">{{
                          formatNumber(formattedNumber(MTDValue)).slice(-1)
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-md-6 col-lg-6 d-flex flex-col align-self-center">
                    <span class="greenspan volume-label h2">RM {{ formatNumber(animatedMTDValue) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card Ft-payment-card1 text-white" v-if="!showText">
          <div class="row">
            <div class="col-md-6 col-lg-6">
              <span class="ms-4 heading-26 fw-bold">National Fraud Portal
              </span>
            </div>
            <div class="col-md-6 col-lg-6 d-flex flex-column justify-content-end align-items-end">
              <span class="ms-2 me-2 heading-14 fs-6">Year-to-Date data as of
                {{ daymonthyear(NationalData?.To_Date_Query) }}</span>
            </div>
          </div>

          <div class="row mx-1 g-0">
            <div class="col-md-6 col-lg-3 mt-1">
              <div class="NS-card-G card text-white p-3 mx-1">
                <div class="row pb-3">
                  <div class="col-10 col-md-10 col-lg-10 d-flex flex-column">
                    <span class="fs-5 FT-font fw-bold">Amount Earmarked
                    </span>
                    <span class="fs-5 FT-font fw-bold">For Recovery</span>
                  </div>
                  <div class="col-2 col-md-2 col-lg-2 d-flex flex-col justify-content-center mt-2">
                    <img class="icons-first-g" :src="AEM" alt="Logo" />
                  </div>
                </div>

                <div class="row pb-1">
                  <span class="greenspan FT-Blue fs-2">RM
                    {{
                      formatNumber(NationalData?.amount_earmarked_for_recovery)
                    }}</span>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-3 mt-1">
              <div class="NS-card-B card text-white p-3 mx-1">
                <div class="row pb-3">
                  <div class="col-10 col-md-10 col-lg-10 d-flex flex-column">
                    <span class="fs-5 FT-font  fw-bold">% Of Funds
                    </span>
                    <span class="fs-5 FT-font  fw-bold">Intercepted</span>
                  </div>
                  <div class="col-2 col-md-2 col-lg-2 d-flex flex-col justify-content-center mt-2">
                    <img class="icons-first-g" :src="perAR" alt="Logo" />
                  </div>
                </div>
                <div class="row pb-2">
                  <span class="bluespan FT-Blue fs-2">{{ NationalData?.pct_amt_reported }}%</span>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-3 mt-1">
              <div class="NS-card-O card text-white p-3 mx-1">
                <div class="row pb-3">
                  <div class="col-10 col-md-10 col-lg-10 d-flex flex-column">
                    <span class="fs-5 FT-font  fw-bold">Incidents Initiated
                    </span>
                    <span class="fs-5 FT-font fw-bold">For Response</span>
                  </div>
                  <div class="col-2 col-md-2 col-lg-2 d-flex flex-col justify-content-center mt-2">
                    <img class="icons-first-g" :src="IIR" alt="Logo" />
                  </div>
                </div>
                <div class="row pb-2">
                  <span class="bluespan FT-Blue fs-2 ">{{
                    formatNumber(NationalData?.incident_initiated_for_response)
                  }}</span>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-3 mt-1">
              <div class="NS-card-B1 card text-white p-3 mx-1">
                <div class="row pb-3">
                  <div class="col-md-9 col-lg-9 d-flex flex-column">
                    <span class="fs-5 FT-font fw-bold">Loss Amount
                    </span>
                    <span class="fs-5 FT-font fw-bold">Reported</span>
                  </div>
                  <div class="col-3 col-md-3 col-lg-3 d-flex justify-content-center flex-col mt-2">
                    <img class="icons-first-RM" :src="AR" alt="Logo" />
                  </div>
                </div>
                <div class="row pb-1">
                  <span class="greenspan FT-Blue fs-2">RM
                    {{ formatNumber(NationalData?.amount_loss_reported) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import axios from "axios";
import {  config, setAuthToken } from '@/config';
const epayment = process.env.https://api.nrtdashboard.prod.inet.paynet.my/paynet/api/get-epayment-data;
const National = process.env.https://api.nrtdashboard.prod.inet.paynet.my/paynet/api/get-national-scam-data;
export default {
  name: "App",

  components: {},

  data: () => ({
    logoPath: require("@/assets/newIcon/paynetLogo.svg"),
    RM: require("@/assets/newIcon/Rm.svg"),
    FTW: require("@/assets/newIcon/fundTransfer.svg"),
    BO: require("@/assets/newIcon/onlinePayment.svg"),
    PSM: require("@/assets/newIcon/store.svg"),
    PB: require("@/assets/newIcon/receipt.svg"),
    CB: require("@/assets/white icons/cross border.svg"),
    Cal: require("@/assets/newIcon/Calender.svg"),
    Clk: require("@/assets/newIcon/Clock.svg"),
    volumeImage: require("@/assets/newIcon/yeartodate.svg"),
    AEM: require("@/assets/newIcon/amountrecover.svg"),
    perAR: require("@/assets/newIcon/d1.svg"),
    IIR: require("@/assets/newIcon/d2.svg"),
    AR: require("@/assets/newIcon/d3.svg"),
    Log: require("@/assets/white icons/logout.svg"),

    NationalData: 0,
    epayment: null,
    YTDVolume: 0,
    MTDVolume: 0,
    YTDValue: 0,
    MTDValue: 0,
    accessToken: "",
    currentIndex: 0,
    showText: true,
    FT_Volume: null,
    FT_Value: null,
    BC_Volume: null,
    BC_Value: null,
    PSM_Volume: null,
    PSM_Value: null,

    PB_Volume: null,
    PB_Value: null,
    CB_Volume: null,
    CB_Value: null,
    currentDate: "",
    currentDate1: "",
    currentTime: "",
    x: 0,
    y: 0,
    currentTotalIndex: 0,
    currentTotal: 0,
    intervalId: 0,

    animatedYTDVolume: null,
    animatedMTDVolume: null,
    animatedYTDValue: null,
    animatedMTDValue: null,
  }),
  async created() {
    await this.userLogin();
  },
  mounted() {
    this.getepayment();
    this.getnational();
    this.getCurrentDateTime();
    setInterval(this.getCurrentDateTime, 1000);
    setInterval(() => {
      this.showText = !this.showText;
    }, 30000);

    this.intervalId = setInterval(this.updateTotal, 9000);
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  },

  methods: {
    async userLogout() {
        await this.$auth.signOut();
        localStorage.removeItem('accessToken'); 
    },
    async userLogin() {
        if (!this.authState?.isAuthenticated) {
            await this.$auth.signInWithRedirect({ originalUri: "/" });
        }
        this.accessToken = await this.$auth.getAccessToken();
        console.log('Paynet Token' , this.accessToken )
        localStorage.setItem('accessToken', this.accessToken); 
    },

    async getepayment() {
      try {
        setAuthToken();
        let response = await axios.get(epayment, config);
        this.epayment = response.data;
        this.updateTotal();
      } catch (error) {
        console.error("Error:", error);
      }
    },
    daymonthyear(dateValue) {
      let date = new Date(dateValue);
      let day = date.getDate();
      let month = date.toLocaleString("en-US", { month: "short" });
      let year = date.getFullYear();
      return `${day} ${month} ${year}`;
    },

    getCurrentDateTime() {
      const malaysiaOffset = 8 * 60 * 60 * 1000;
      const date = new Date(Date.now() + malaysiaOffset);
      const optionsDate = { day: "2-digit", month: "2-digit", year: "numeric" };
      this.currentDate = date.toLocaleDateString("en-US", optionsDate);
      const malaysiaTimezone = "Asia/Kuala_Lumpur";
      this.currentDate1 = new Date();
      const options = {
        timeZone: malaysiaTimezone,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      };
      this.currentTime = this.currentDate1.toLocaleString("en-MY", options);
    },

    formatNumber1(number) {
      return number.toLocaleString("en-US", {
        minimumIntegerDigits: 3,
      });
    },
    formattedNumber(Number) {
      if (Number >= 0 && Number < 999) {
        return Number.toString() + " ";
      } else if (Number >= 1000 && Number <= 9999999) {
        const rounded = Math.round(Number / 1000);
        return rounded % 1 === 0 ? rounded + "K" : rounded.toFixed(1) + "K";
      } else if (Number >= 10000000 && Number <= 9999999999) {
        const rounded = Math.round(Number / 1000000);
        return rounded % 1 === 0 ? rounded + "M" : rounded.toFixed(1) + "M";
      } else if (Number >= 10000000000 && Number <= 9999999999999) {
        const rounded = Math.round(Number / 1000000000);
        return rounded % 1 === 0 ? rounded + "B" : rounded.toFixed(1) + "B";
      } else if (Number >= 10000000000000 && Number <= 9999999999999999) {
        const rounded = Math.round(Number / 1000000000000);
        return rounded % 1 === 0 ? rounded + "T" : rounded.toFixed(1) + "T";
      } else if (Number >= 10000000000000000) {
        const rounded = Math.round(Number / 1000000000000000);
        return rounded % 1 === 0 ? rounded + "Q" : rounded.toFixed(1) + "Q";
      }
    },
    formatNumber(number) {
      if (number !== null && number !== undefined) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "";
      }
    },
    async getnational() {
      try {
        setAuthToken();
        let response = await axios.get(National, config);
        this.NationalData = response.data[response.data.length - 1];
      } catch (error) {
        console.error("Error:", error);
      }
    },

    animateVolume(volume, property) {
      let remainingDigits = Math.floor(volume / 1000);
      let lastThreeDigits = volume % 1000;
      let animatedVolume = 0;
      const animationSteps = 5;
      const animationDuration = 8000;
      let stepValue = lastThreeDigits / animationSteps;
      let stepCount = 0;

      const animationInterval = setInterval(() => {
        if (stepCount < animationSteps) {
          animatedVolume += stepValue;
          stepCount++;
          this[property] = remainingDigits * 1000 + Math.floor(animatedVolume);
        } else {
          clearInterval(animationInterval);
          this[property] = volume;
        }
      }, animationDuration / animationSteps);
    },
    updateTotal() {
      let now = new Date();
      let currentMinute = now.getMinutes().toString().padStart(2, "0");
      let matchingData = this.epayment.filter(
        (item) => item.mt === parseInt(currentMinute, 10)
      );

      if (matchingData.length > 0) {
        let data = matchingData[this.currentTotalIndex % matchingData.length];
        this.YTDVolume = data.total_e_payment_txn_ytd;
        this.MTDVolume = data.total_e_payment_txn_mtd;
        this.YTDValue = data.total_e_payment_amt_ytd;
        this.MTDValue = data.total_e_payment_amt_mtd;

        this.FT_Volume = data.total_fund_transfers_txn;
        this.FT_Value = data.total_fund_transfers_amt;

        this.BC_Volume = data.total_buy_at_ecommerce_txn;
        this.BC_Value = data.total_buy_at_ecommerce_amt;

        this.PSM_Volume = data.total_pay_store_merchant_txn;
        this.PSM_Value = data.total_pay_store_merchant_amt;

        this.PB_Volume = data.total_pay_bills_txn;
        this.PB_Value = data.total_pay_bills_amt;

        this.CB_Volume = data.total_cross_border_txn;
        this.CB_Value = data.total_cross_border_amt;

        this.currentTotalIndex++;

        this.animateVolume(this.YTDVolume, "animatedYTDVolume");
        this.animateVolume(this.MTDVolume, "animatedMTDVolume");
        this.animateVolume(this.YTDValue, "animatedYTDValue");
        this.animateVolume(this.MTDValue, "animatedMTDValue");
      }
    },
  },
};
</script>

<style scoped>
.linebottom {
  border-bottom: 1px solid #5b6876;
  margin-left: 0.3rem;
  margin-right: 0.3rem;
}

.linebottom1 {
  border-bottom: 1px solid #5b6876;
  margin-left: 0.1rem;
  margin-right: 0.1rem;
}

.labeltext {
  color: #b0b0b0 !important;
}

.container-fluid {
  width: 97%;
  max-width: 100%;
  padding: 0;
  margin: 0 auto;
  box-sizing: border-box;
}

.payment-card .no-gutters {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.header-card {
  background-color: #15191e;
  border: 0.1px solid #15191e;
}

.logo-icon {
  max-height: 3.6rem;
}

.icons-first {
  max-height: 1.25rem;
}

.bluespan {
  color: #8bc5f5;
}

.greenspan {
  color: #99d3a0;
}

.heading-26 {
  font-size: 1.62rem;

  font-weight: 500;
  font-family: "Open Sans", sans-serif !important;
  color: #d2d2d2 !important;
}

.heading-20 {
  font-size: 1.25rem;
}

.Ft-payment-card {
  background-color: #15191e;
  border: 0.1px solid #15191e;
}

.Ft-payment-card1 {
  background-color: #15191e;
  border: 0.1px solid #15191e;
}

.year-card {
  background-color: #262d36;
  border: 1px solid #394655;
  border-radius: 0.8rem;
}

.FT-card {
  background-color: #262d36;
}

.icons-first-g {
  height: 1.8rem;
  position: relative;
  z-index: 1;
}

.icons-first-RM {
  height: 1.6rem;
  position: relative;
  z-index: 1;
}

.Fund-transfer {
  gap: 0.6rem;
}

.FT-card-G {
  background-color: #262d36;
  border: 1px solid #394655;
  border-radius: 0.8rem;
}

.FT-card-B {
  background-color: #262d36;
  border: 1px solid #394655;
  border-radius: 0.8rem;
}

.FT-card-O {
  background-color: #262d36;
  border: 1px solid #394655;
  border-radius: 0.8rem;
}

.FT-card-B1 {
  background-color: #262d36;
  border: 1px solid #394655;
  border-radius: 0.8rem;
}

.FT-card-G1 {
  background-color: #262d36;
  border: 1px solid #394655;
  border-radius: 0.8rem;
}

.NS-card-G {
  background-color: #262d36;
  border: 1px solid #394655;
  border-radius: 0.8rem;
}

.NS-card-B {
  background-color: #262d36;
  border: 1px solid #394655;
  border-radius: 0.8rem;
}

.NS-card-O {
  background-color: #262d36;
  border: 1px solid #394655;
  border-radius: 0.8rem;
}

.NS-card-B1 {
  background-color: #262d36;
  border: 1px solid #394655;
  border-radius: 0.8rem;
}


@media (min-width: 992px) {
  .Ft-payment-card {
    max-height: 30rem !important;
  }

  .heading-26 {
    font-size: 1rem !important;
  }

  .logo-icon {
    max-height: 2.3rem !important;
  }

  .ytd {
    font-size: 0.8rem !important;
  }

  .img-fluid-AR {
    width: 1.5rem !important;
  }

  .img-fluid-Rm {
    width: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .volume-label {
    font-size: 0.9rem !important;
  }

  .FT-font {
    font-size: 0.8rem !important;
  }

  .FT-Blue {
    font-size: 1rem !important;
  }

  .icons-first-RM {
    height: 1.2rem !important;
  }
}

@media (min-width: 1200px) {
  .span1 {
    font-size: 0.8rem !important;
  }

  .icons-first {
    max-height: 0.9rem !important;
  }

  .Ft-payment-card {
    max-height: 33rem !important;
  }

  .heading-26 {
    font-size: 1rem !important;
  }

  .header-card {
    height: 3.1rem !important;
  }

  .year-card {
    height: 11rem;
  }

  .dualRow {
    height: 3.3rem !important;
  }

  .volume-label {
    font-size: 1.2rem !important;
  }

  .ytd {
    font-size: 1rem !important;
  }

  .img-fluid-AR {
    width: 1.5rem !important;
  }

  .img-fluid-Rm {
    width: 2rem !important;
    margin-left: 1.5rem !important;
  }

  .vol {
    font-size: 0.7rem !important;
  }

  .heading-14 {
    font-size: 0.8rem !important;
  }

  .FT-font {
    font-size: 1rem !important;
  }

  .FT-Blue {
    font-size: 1.2rem !important;
    padding-top: 5px !important;
  }

  .logo-icon {
    max-height: 2.9rem !important;
  }

  .FT-card-G {
    height: 9rem !important;
  }

  .FT-card-B {
    height: 9rem !important;
  }

  .FT-card-O {
    height: 9rem !important;
  }

  .FT-card-B1 {
    height: 9rem !important;
  }

  .FT-card-G1 {
    height: 9rem !important;
  }

  .NS-card-G {
    height: 9rem !important;
  }

  .NS-card-B {
    height: 9rem !important;
  }

  .NS-card-O {
    height: 9rem !important;
  }

  .NS-card-B1 {
    height: 9rem !important;
  }

  .NS-card-G::before {
    height: 76%;
  }

  .NS-card-B::before {
    height: 76%;
  }

  .NS-card-O::before {
    height: 76%;
  }

  .NS-card-B1::before {
    height: 76%;
  }

  hr {
    margin: 0;
  }

  .icons-first-RM {
    height: 1.4rem;
  }
}

@media (min-width: 1400px) {
  .span1 {
    font-size: 0.8rem !important;
  }

  .Ft-payment-card {
    max-height: 35rem !important;
  }

  .heading-26 {
    font-size: 1.3rem !important;
  }

  .icons-first-RM {
    height: 1.4rem !important;
  }

  .header-card {
    height: 3.1rem !important;
  }

  .labeltext {
    color: #b0b0b0 !important;
  }

  .volume-label {
    font-size: 1.4rem !important;
  }

  .ytd {
    font-size: 1rem !important;
  }

  .icons-first {
    max-height: 0.9rem !important;
  }

  .img-fluid-AR {
    width: 1.6rem !important;
  }

  .img-fluid-Rm {
    width: 2rem !important;
    margin-left: 1.5rem !important;
  }

  .vol {
    font-size: 0.7rem !important;
  }

  .heading-14 {
    font-size: 0.8rem !important;
  }

  .FT-font {
    font-size: 1rem !important;
  }

  .FT-Blue {
    font-size: 1.4rem !important;
    padding-top: 5px !important;
  }

  .logo-icon {
    max-height: 2.9rem !important;
  }

  .FT-card-G {
    height: 9rem !important;
  }

  .FT-card-B {
    height: 9rem !important;
  }

  .FT-card-O {
    height: 9rem !important;
  }

  .FT-card-B1 {
    height: 9rem !important;
  }

  .FT-card-G1 {
    height: 9rem !important;
  }

  .NS-card-G {
    height: 9rem !important;
  }

  .NS-card-B {
    height: 9rem !important;
  }

  .NS-card-O {
    height: 9rem !important;
  }

  .NS-card-B1 {
    height: 9rem !important;
  }

  .NS-card-G::before {
    height: 76%;
  }

  .NS-card-B::before {
    height: 76%;
  }

  .NS-card-O::before {
    height: 76%;
  }

  .NS-card-B1::before {
    height: 76%;
  }

  hr {
    margin: 0;
  }
}

@media (min-width: 2560px) {
  .img-fluid-AR {
    width: 4rem;
  }

  .img-fluid-Rm {
    width: 4rem;
    margin-left: 1.5rem;
  }

  .heading-26 {
    font-size: 1.62rem;
    font-weight: 500;
  }

  .heading-20 {
    font-size: 1.12rem;
  }

  .heading-14 {
    font-size: 0.8rem !important;
  }

  .ytd {
    font-size: 2.37rem;
  }

  .volume-label {
    font-size: 3.12rem;
    font-weight: 500;
  }

  .FT-Blue {
    font-size: 1.12rem !important;
    font-weight: 500;
  }

  .FT-font {
    font-size: 1rem !important;
    padding-top: 5px;
  }

  .icons-first-g {
    height: 2.5rem;
    position: relative;
    z-index: 1;
  }

  .logo-icon {
    max-height: 3.75rem;
  }

  .vol {
    font-size: 1.5rem;
  }
}
</style>